import { useState } from "react";
import { useDispatch } from "react-redux";

import { bulkApproveCompanyEventRequestsRequest } from "../../../../../../store/CompanyPortal/EventRequests/actions";
import { bulkApproveAdminEventRequestsRequest } from "../../../../../../store/AdminEventRequests/actions";

const useApproveRequests = ({
  portalVariant = "company-portal",
  eventId,
  rows,
  selectedIds,
  listParams,
  setSelectedIds,
}) => {
  const isAdminPortal = portalVariant === "admin-portal";
  const dispatch = useDispatch();
  const [approveTarget, setApproveTarget] = useState({
    ids: [],
    variant: "approve",
  });
  const approveTargetIds = approveTarget.ids;
  const approveApplicants = rows.filter((row) =>
    approveTargetIds.includes(row.id),
  );

  const openApproveModal = () => {
    setApproveTarget({ ids: selectedIds, variant: "approve" });
  };

  const closeApproveModal = () => {
    setApproveTarget({ ids: [], variant: "approve" });
  };

  const confirmApprove = ({ role, shift }) => {
    const payload = {
      eventRequestIds: approveTargetIds,
      roleId: role?.id,
      eventRoleShiftId: shift?.id,
      listParams,
      onSuccess: () => {
        setSelectedIds([]);
        setApproveTarget({ ids: [], variant: "approve" });
      },
    };

    if (isAdminPortal) {
      dispatch(
        bulkApproveAdminEventRequestsRequest({
          ...payload,
          eventId,
        }),
      );
      return;
    }

    dispatch(bulkApproveCompanyEventRequestsRequest(payload));
  };

  return {
    approveApplicants,
    approveModalVariant: approveTarget.variant,
    isApproveModalOpen: approveTargetIds.length > 0,
    openApproveModal,
    closeApproveModal,
    confirmApprove,
  };
};

export default useApproveRequests;
